<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <p>{{ text }}</p>
  <p class="status-change-sub-text">{{ subText }}</p>

  <table class="status-change-reason full-width">
    <tr>
      <td [style.width]="showCustomReasonInput() ? '25%' : '100%'">
        <div *ngIf="selectableReasons" class="status-change-reason-drop-down">
          <mat-form-field class="full-width">
            <mat-select [(ngModel)]="selectedReason" placeholder="Select a reason" required>
              <mat-option *ngFor="let reason of selectableReasons" [value]="reason">
                {{ reason }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </td>
      <td *ngIf="showCustomReasonInput()" style="width: 75%;">
        <mat-form-field class="full-width">
          <input [(ngModel)]="reasonText" matInput placeholder="Custom reason" required type="text">
        </mat-form-field>
      </td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="onNoClick()" cdkFocusInitial color="accent" mat-raised-button>{{ cancel }}</button>
  <button (click)="onYesClick()" [disabled]="isYesDisabled()" color="primary" mat-raised-button>{{ confirm }}</button>
</mat-dialog-actions>
